// extracted by mini-css-extract-plugin
export var grayCircle = "_dv-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dv-1";
export var selectedCircle = "_dv-2";
export var shippingOptionImage = "_dv-3";
export var shippingOptionWidgetPreview = "_dv-4";